import { atom } from 'jotai';

export const isClinicianSelectShortcutsDisabledAtom = atom<boolean>(false);
